/**
 * Vervolg behandeltijd-rapportage, CAP-4 — een tijdstip in Amsterdamse tijd.
 *
 * Een tijdstip uit de bron is UTC. Het scherm toont het op de klok van Amsterdam, ongeacht de tijdzone
 * van de browser: een manager op een UTC-laptop ziet dezelfde 09:12 als een manager in Amsterdam.
 */
export const AMSTERDAM_TIJDZONE = 'Europe/Amsterdam';

export function formatAmsterdamTijd(iso: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, {
    timeZone: AMSTERDAM_TIJDZONE,
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}

const KLOK_AMSTERDAM = new Intl.DateTimeFormat('en-GB', {
  timeZone: AMSTERDAM_TIJDZONE,
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** Minuten sinds middernacht op de klok van Amsterdam, op het moment `ms` (UTC-milliseconden). */
export function amsterdamMinuutVanDag(ms: number): number {
  const [uur = 0, minuut = 0] = KLOK_AMSTERDAM.format(new Date(ms)).split(':').map(Number);
  return uur * 60 + minuut;
}

/**
 * Het moment waarop de voorlopig-melding bij de tot-datum verdwijnt (behandeltijd-rapport, CAP-5):
 * 02:00 Amsterdamse tijd op de dag ná `to`, in winter en zomer.
 *
 * Twee gevallen rond de omschakeling. Op de dag naar winter bestaat 02:00 twee keer; de latere telt,
 * zodat de melding niet te vroeg verdwijnt. Op de dag naar zomer bestaat 02:00 niet; dan loopt de
 * melding tot 03:00, dus tot 01:00 UTC.
 */
export function voorlopigTot(to: string): Date {
  const [jaar = 0, maand = 1, dag = 0] = to.slice(0, 10).split('-').map(Number);
  const middernacht = Date.UTC(jaar, maand - 1, dag + 1);
  const winter = middernacht + 3_600_000;
  if (amsterdamMinuutVanDag(winter) === 120) return new Date(winter);
  if (amsterdamMinuutVanDag(middernacht) === 120) return new Date(middernacht);
  return new Date(winter);
}

/** Of de voorlopig-melding op het moment `nu` nog zichtbaar is voor de periode die op `to` eindigt. */
export function voorlopigZichtbaar(to: string, nu: Date): boolean {
  return nu.getTime() < voorlopigTot(to).getTime();
}
